'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Auth = _interopRequireDefault(require("Layouts/Auth"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = typeof window !== 'undefined' ? window.app : undefined;
class NotAllowedPage extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      roles: []
    });
    (0, _defineProperty2.default)(this, "handleSessionChange", _ref => {
      let {
        source,
        data
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;
      component.setState({
        roles: app.state.session.user.roles
      });
    });
  }
  componentDidMount() {
    var _app$state$session, _app$state$session$us;
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if ((_app$state$session = app.state.session) !== null && _app$state$session !== void 0 && (_app$state$session$us = _app$state$session.user) !== null && _app$state$session$us !== void 0 && _app$state$session$us.id) {
      component.handleSessionChange({
        source: 'DidMount'
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)({
      error: app.state.form_error
    });
    const default_error = state.roles.length === 0 ? 'Connectez-vous pour accéder à cette page' : 'Vous n\'avez pas la permission d\'accéder à cette page.';
    let output = /*#__PURE__*/_react.default.createElement(_Auth.default, (0, _extends2.default)({
      page_title: "Acc\xE8s refus\xE9"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "login-page__left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "auth-logo-link",
      href: (0, _Routing.URL)('Login')
    }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    })), status.length === 0 ? (0, _getFormStatus.default)({
      error: default_error
    }) : status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      size: "small",
      href: state.roles.length === 0 ? (0, _Routing.URL)('Login') : (0, _Routing.URL)('UserHomePage')
    }, state.roles.length === 0 ? 'Page de connexion' : 'Retour a l\'accueil')))), /*#__PURE__*/_react.default.createElement("div", {
      className: "login-page__right"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "login-page__title"
    }, "Acc\xE8s refus\xE9"))));
    return output;
  }
}
exports.default = NotAllowedPage;
